import { UserInfo } from '@Entities/user/user'
import { USER_FORM } from '@Const/forms-constants'
import React from 'react'

interface AddressSectionProps {
    userInfo: UserInfo
    countryTitle: string
}

const AddressSection = (props: AddressSectionProps) => {
    const { userInfo, countryTitle } = props
    return (
        <section className="address-section">
            <h5>Address</h5>
            <div className="fields-row-container">
                <div className="field-block">
                    <p className="small title">{USER_FORM.streetAddress.label}</p>
                    <p className="value">{userInfo.streetAddress}</p>
                </div>
                <div className="field-block">
                    <p className="small title">{USER_FORM.unitNumber.label}</p>
                    <p className="value">{userInfo.unitNumber}</p>
                </div>
                <div className="field-block">
                    <p className="small title">{USER_FORM.city.label}</p>
                    <p className="value">{userInfo.city}</p>
                </div>
                <div className="field-block">
                    <p className="small title">{USER_FORM.state.label}</p>
                    <p className="value">{userInfo.state}</p>
                </div>
                <div className="field-block">
                    <p className="small title">{USER_FORM.country.label}</p>
                    <p className="value">{countryTitle}</p>
                </div>
                <div className="field-block">
                    <p className="small title">{USER_FORM.postalCode.label}</p>
                    <p className="value">{userInfo.postalCode}</p>
                </div>
            </div>
        </section>
    )
}
export default AddressSection
